import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { PermissionsContext } from '../Contexts/Permissions';
import Constants from '../assests/Constants/constants';
import { isRestricted } from '../assests/Constants/menuRestrictionKeys';

/**
 * Redirects to /unauthorized when the current user is a SubAccountant and the given document type
 * (e.g. 'CreditNote', 'TaxInvoice') is in their restrictions for the current case.
 * Use on CreateInvoice, CreateLawyerInvoice, CreateReceipt pages with location.state?.type.
 * @param {string | undefined} documentType - e.g. location.state?.type ('CreditNote', 'TaxInvoice', ...)
 */
export function useRequireDocumentTypeAccess(documentType) {
    const navigate = useNavigate();
    const { userTypeContext, subAccountantCaseRestrictions } = useContext(PermissionsContext);

    useEffect(() => {
        if (!documentType || typeof documentType !== 'string') return;
        const isSubAccountant = userTypeContext?.toString() === Constants.UserType.SubAccountant;
        if (!isSubAccountant) return;

        const restrictions = subAccountantCaseRestrictions || [];
        if (isRestricted(restrictions, documentType.trim())) {
            navigate('/unauthorized', { replace: true });
        }
    }, [documentType, userTypeContext, subAccountantCaseRestrictions, navigate]);
}
